import React, { Component } from 'react';
import { findVendor } from '../../vendor';
import { PropertyInfo } from './PropertyInfo';

export class Property extends Component {

    displayName = this.props.property.Name;

    constructor(props) {
        super(props);
        this._handleCheck = this._handleCheck.bind(this);
    }

    _handleClick = (e) => {
        e.preventDefault();
        const { property, onClick } = this.props;
        onClick(property.Id);
    }

    _handleCheck() {
        const { property, onCheck, onClick } = this.props;
        onCheck(property.Id);
        // Ticking a property also reveals its description on the right,
        // exactly as clicking the row body does, so the customer sees
        // what they just added or removed.
        onClick(property.Id);
    }

    // Returns true if the property is billable, otherwise false.
    getIsBillable(property) {
        const availableProperties = this.props.availableProperties;
        var isBillable = true;
        if (availableProperties.Products[property.VendorId]) {
            // Case-insensitive: the cloud does not always report names in
            // the catalogue's casing (agent-signature reports them lowercase).
            isBillable = !availableProperties.Products[property.VendorId].Properties.find((prop) => {
                return (property.VendorId + "." + prop.Name).toUpperCase() ===
                    property.Id.toUpperCase();
            });
        }   
        return isBillable;
    }

    back = () => {
        const { onClick } = this.props;
        onClick('');
    }

    // The lowest plan whose subscription includes this property. The
    // Plans labels arrive cheapest first from the backend (PlanMapper),
    // so the first entry is the plan to show on the row badge.
    getPlanLabel(property, isBillable) {
        if (property.Plans && property.Plans.length > 0) {
            return property.Plans[0];
        }
        // No Cloud V5 plan carries the property, so it needs a
        // conversation. Free properties always carry a label.
        return isBillable ? "Bespoke" : "Free";
    }

    render() {
        const property = this.props.property;
        const isBillable = this.getIsBillable(property);
        const planLabel = this.getPlanLabel(property, isBillable);
        const vendor = findVendor(this.props.vendors, property.VendorId);
        const checked = this.props.checked;
        return (
            <li className={`g-panel__item ${this.props.active ? "is-active" : ""}`}>
                <div className="c-option">
                    <span className="c-select  c-select--large">
                        <input type="checkbox" className="c-select__input is-selectable" id={property.Id} data-property={property.Id} onChange={this._handleCheck} checked={checked}/>
                        <label className="c-select__label" htmlFor={property.Id}>
                            <span className="c-select__text">{this.displayName}</span>
                        </label>
                    </span>
                    <a href="#" className={`c-option__link is-revealable ${this.props.active ? "is-active" : ""}`} onClick={this._handleClick}>
                        {this.displayName}
                        <span className="c-option__additional">
                            <span className="c-option__vendor"><img src={vendor.iconUrl} alt={vendor.name} width="13" height="13" /></span>
                            {isBillable ? <span className="c-option__billable"><span>{planLabel}</span></span> : null}
                            <span className="c-option__info"><span>Info</span></span>
                        </span>
                    </a>
                </div>
                <PropertyInfo
                    property={property}
                    category={this.props.category}
                    isBillable={isBillable}
                    planLabel={planLabel}
                    active={this.props.active}
                    back={this.back}
                    checked={checked}
                    onCheck={this._handleCheck}
                    vendor={vendor}
                    examples={this.props.examples}
                />
            </li>
        );
    }
}